<template>
<div class="chapter">
<div class="inner_page">
<p class="colophon"><span>Europa Editions<br/>
 27 Union Square West, Suite 302<br/>
New York NY 10003<br/>
  info@europaeditions.com<br/>
  www.europaeditions.com<br/>
<br/>
  This book is a work of fiction. Any references to historical events, real people, or real locales are used fictitiously.<br/>
<br/>
  Copyright © 2022 by Andrew Miller<br/>
  First publication 2022 by Europa Editions<br/>
<br/>
  All rights reserved, including the right of reproduction in whole or in part in any form.<br/>
<br/>
  Art direction by Emanuele Ragnisco<br/>
instagram.com/emanueleragnisco<br/>
<br/>
Cover design and image by Ginevra Rapisardi<br/>
<br/>
Cover image: collage of Unsplash images<br/>
<br/>
  ISBN 9781609458010 <br/>
</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Colophon.vue?0fc1e494